<template>
  <v-container grid-list-xl text-xs-center>
    <form>

    <v-layout v-if="loading">
      <v-flex>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs12 v-show="!event.description">
        <v-alert
          :value="true"
          type="info"
        >
          No hay ningún evento disponible para tomar asistencia.
        </v-alert>
      </v-flex>
        <v-flex xs12 sm6 md6 v-if="signatureEvent">
          <v-card>
            <v-card-title class="primary font-weight-bold white--text">Firma:</v-card-title>
            <VueSignaturePad
              width="450px"
              height="200px"
              ref="signaturePad"
            />
            <v-card-actions>
              <v-btn medium @click="save" :disabled="loading" color="primary">Guardar</v-btn>
              <v-btn medium @click="undo" >Deshacer</v-btn>
              <v-btn medium @click="clear" >Limpiar</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>


    <v-flex v-show="event.description && signatureEvent==false" xs12 sm5 md6 offset-xs0 >
      
      <v-layout row>
        <v-flex xs 12>
          <div class="headline">
            Toma de asistencia del evento {{ event.description }} {{ event.events_date }} {{ time }} con categoría {{event.category}}
          </div>     
          <v-autocomplete
            :search-input.sync="search"
            v-model="currentFamilySearch"
            :items="resultFami"
            no-data-text="No hay datos para la busqueda"
            :loading="isLoading"
            item-text="name"
            item-value="name"
            clearable
            cache-items
            label="Buscar Familia"
            hide-selected
          >
          </v-autocomplete>
                 <v-btn v-show="event.close_assistance" @click="closeAssistance" :disabled="loading" color="blue darken-1" >Cerrar asitencia</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm5 md6 offset-xs0 v-if="currentFamilySearch  && (parents.mother || parents.father)">
      <v-card elevation-10>
          <v-card-title class="subheading font-weight-bold primary white--text">Chequeo padres asistentes al evento: {{ event.description }}</v-card-title>
          <v-list dense>
            <v-list-tile v-if="parents.father">
              <v-checkbox
                :disabled="form.delegate_allowed"
                name="assistFather"
                v-model="form.assistFather"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Padre:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ parents.father }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="parents.mother">
              <v-checkbox
                :disabled="form.delegate_allowed"
                name="assistMother"
                v-model="form.assistMother"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Madre:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ parents.mother }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-show="event.delegate_allowed == 1">
              <v-checkbox
              class="check"
              :disabled="form.assistFather || form.assistMother"
                name="delegate_allowed"
                v-model="form.delegate_allowed"
              ></v-checkbox>
              <v-list-tile-content class="font-weight-bold">Delegado</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-text>
            <text-input
              v-show="form.delegate_allowed"
              :form="form"
              v-model="form.delegate"
              label="Delegado"
              error-messages="messageValidate.delegateMessage"
              :v-errors="errors"
              :value.sync="form.delegate"
              counter="100"
              name="delegate"
              v-validate="'max:100|'"
            ></text-input>
             <div class='red--text'>{{messageValidate.delegateMessage}}</div>
            <text-input
              v-show="form.delegate_allowed"
              :form="form"
              v-model="form.delegated_kinship"
              label="Parantesco delegado"
              :v-errors="errors"
              :value.sync="form.delegated_kinship"              
              :error-messages="messageValidate.delagateMessage"
              counter="30"
              name="delegate"
              v-validate="'max:30|'"
            ></text-input>
            <div class='red--text'>{{messageValidate.delegated_kinship}}</div> 
            <text-input
              :form="form"
              v-model="form.observation"
              label="Observación"
              :v-errors="errors"
              :value.sync="form.Observation"
              counter="100"
              name="observation"
              v-validate="'max:100|'"
            ></text-input> 
          </v-card-text>
          <v-card-actions>
            <v-btn v-show="!event.requires_signature" @click="getDate()" color="green darken-1" >Tomar asistencia</v-btn>
            <v-btn v-show="event.requires_signature" @click="signatureEvent=true" color="yellow darken-1" >Firmar evento</v-btn>
          </v-card-actions>              
      </v-card>
    </v-flex>
      </v-layout>
      <br>
      <br>
      <br>
      <hr>
      <!-- dataTable-->
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <v-card>
              <v-card-title>
              <v-text-field
                  v-model="searchDataTable"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
              ></v-text-field>
              </v-card-title>
              <v-data-table
              :headers="headers"
              :items="assists"
              :search="searchDataTable"
              >
              <template slot="items" slot-scope="props">
                  <td class="text-xs-center">{{ props.item.family }}</td>
                  <td class="text-xs-center">{{ props.item.father }}</td>
                  <td class="text-xs-center">{{ props.item.mother }}</td>
                  <td class="text-xs-center" v-if="props.item.assistFather && props.item.assistMother">Padres</td>
                  <td class="text-xs-center" v-else-if="props.item.assistFather">Papá</td>
                  <td class="text-xs-center" v-else-if="props.item.assistMother">Mamá</td>
                  <td v-else class="text-xs-center">Delegado</td>
                  <td class="text-xs-center">{{ props.item.observation }}</td>                
                  <td class="text-xs-center">{{ props.item.date }}</td>                
                  <td class="text-xs-center">
                  <v-btn  color="primary" small @click="seeSignature(props.item.signatureUrl)">Ver firma</v-btn>
                  </td>
              </template>
              </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>  
    </form>
            <v-dialog
            v-model="dialog"
            width="500"
            >
            <v-card>
                <v-img
                :src="signature_url"
                aspect-ratio="1"
                class="grey lighten-2"
                contain
                height="250"
                />
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    flat
                    @click="dialog = false"
                >
                    Cerrar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </v-container>

</template>

<script>
import Form from 'vform';
import axios from 'axios';
export default {
  data () {
    return {
      searchDataTable: '',
      signature_url: '',
      dialog: false,
      assists: [
      ],
      search: null,
      headers: [
          { text: 'Familia', align: 'center', value: 'family', sortable: true },
          { text: 'Padre', align: 'center', value: 'father', sortable: false },
          { text: 'Madre', align: 'center', value: 'mother', sortable: false },
          { text: 'Asistente', align: 'center', value: 'date', sortable: false },
          { text: 'Observación', align: 'center', value: 'observation', sortable: false },
          { text: 'Fecha Asistencia', align: 'center', value: 'date', sortable: false },
          { text: 'Firma', align: 'center', value: 'signatureUrl', sortable: false }
      ],
      signatureEvent: false,
      resource: false,
      validated: {
      message: '',
      errors: false
      },
      EventSave: {
        "data": [],
        "eventId": []
      },
      form: new Form({
        assistMother: false,
        assistFather: false,
        signatureUrl: '',
        delegate: '',
        delegate_allowed: false,
        observation: '',
      }),
      isLoading: false,
      currentFamilySearch: null,
      resultFami: [],
      familySentAgent: false,
      loading: false,
      event: [],
      time: '',
      parents: {},
      messageValidate: {
        delegateMessage: '',
        delegated_kinship: ''
      }
    }
  },
  methods: {
    async familyAll(id){
      await axios.get(`/api/events/family/all/` + id)
        .then(res => {
          const { data } = res
          this.count = data.length;
            this.resultFami = data.map(obj=>{
              return {
              id:obj.id,
              id_family: obj.id_family,
              name: obj.name
              }
            })
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    seeSignature (url) {
      this.signature_url = url;
      this.dialog = true;
    },
    closeAssistance () {
      this.loading = true;
      let data = {
        eventId: this.eventId
      }
      axios.post('/api/events/close', data)
        .then(resp=>{
          this.loading = false;
          if (resp.data.status == 202) {
              this.$store.dispatch('responseMessage', {
              type: 'success',
              title: 'Noticia',
              text: 'Evento cerrado con éxito',
              modal: true
            })
            this.$router.push({name: 'event.show'}) 
          }else {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Noticia',
              text: 'Evento cerrado con éxito',
              modal: true
            })
          }
        });
    },
    async save() {
      if(this.$refs.signaturePad.saveSignature().isEmpty){ 
        return;
      }
      if(this.form.delegate_allowed) {
        if (this.form.delegate == '')  {
          this.messageValidate.delegateMessage = 'Este campo es obligatorio';
            return true;
          }
        if (this.form.delegated_kinship == '')  {
          this.messageValidate.delegated_kinship = 'Este campo es obligatorio'
          return;
          }
      }
      let data = {
        signature: this.$refs.signaturePad.saveSignature().data,
        eventId: this.eventId,
        familyId: this.form.familyId
      }
      this.loading = true;
      await axios.post("/api/events/upload/signature", data)
        .then(async resp=>{
          if(resp.data.status==201){
            this.form.signatureUrl = resp.data.data;
            this.getDate();            
          }else{
          this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Noticia',
          title: 'Se presento un error al guardar la firma intente de nuevo',
          modal: true
        })
          }
        })
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    async getDate (param) {
      this.loadingTable = true;
     await axios.get('/api/events/getdate').
      then(resp=>{
        this.form.date = resp.data.date;
        this.takeAssistance(param)
        this.loadingTable = false;
        this.signatureEvent = false;
        this.clearForm()
      })
     },
     clearForm(current=true){
        if (current){
          this.currentFamilySearch = null;
        }
        this.parents = {}
        this.form.observation = '';
        this.form.assistFather = false;
        this.form.assistMother = false;
        this.form.delegate_allowed = false;
        this.form.delegate = '';
        this.form.delegated_kinship = '';
     },
    takeAssistance (param=false) {
      this.loading = true;
        let data = {
          "familyId": this.form.familyId,
          "family": this.form.family,
          "mother": this.parents.mother,
          "father": this.parents.father,
          "assistFather": this.form.assistFather,
          "assistMother":this.form.assistMother,
          "delegate":this.form.delegate,
          "delegate_allowed":this.form.delegate_allowed,
          "observation": this.form.observation,
          "date": this.form.date,
          "signatureUrl": this.form.signatureUrl
        }
        this.EventSave.data.push(data)
        let eventId = {
          eventId: this.eventId
        }
        this.EventSave.eventId.push(eventId)

      /*var names = this.EventSave.data.map(function (person) { return person.familyId; });
      var sorted = names.sort();

      var unique = sorted.filter(function (value, index) {
          return value !== sorted[index + 1];
      });
      this.EventSave.data = unique */
      axios.post("/api/events/assistance", this.EventSave)
        .then(resp=>{
          this.getEventSaveOld()          
          this.loading = false;
        }).catch(error=>{
          this.loading = false;
          if (param) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Noticia',
              text: 'Se prujo un error intenta de nuevo',
              modal: true
              })
              }

        });
    },
    requestHandler (){
      axios.all([
        this.getEventSaveOld(), //or direct the axios request
        this.getEvent()
      ])
    .then(axios.spread((getEventSaveOld, getEvent) => {
        }))
    },
    getEventSaveOld () {
      this.EventSave.data = []
      this.assists = []
      this.loading = true;
      axios.get('/api/events/' + this.eventId)
      .then(resp=>{
        const { data, status } = resp;
        if(data){
          this.EventSave.data = data;
          let dataTable = data
          dataTable.forEach(element => {
            this.assists.push(element)
          });  
          this.loading = false;
        }
      }).catch(error=>{
        this.loading = false;
      })
    }, 
    getEvent () {
      this.loading = true;
      axios.get('/api/events/get/' + this.eventId)
        .then(resp=>{
          const { data, status } = resp;
          this.event = data;
          let extract = this.event.events_time.split(':',2);
          this.time = extract[0] + ':' + extract[1]          
          this.loading = false;
        }).catch(error=>{
          this.loading = false;
          console.log(error)
        });
    }
  },
  mounted (){
    this.eventId = this.$route.params.id;
    this.familyAll(this.eventId)
    this.requestHandler()
  },
  watch: {
    search: async function(val){
      this.resultFami = [];
      if (val==null || val=="") {
      this.search = null
        this.isLoading = false
        this.resultFami = [];
        return
      }

      if (this.isLoading) return
      this.isLoading = true
      let data ={
        search: val,
        eventId:  this.eventId,
      }
      await axios.post(`/api/events/family/search`, data)
        .then(res => {
          const { data } = res
          this.count = data.length;
            this.resultFami = data.map(obj=>{
              return {
              id:obj.id,
              id_family: obj.id_family,
              name:obj.name
              }
            })
                                   this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    currentFamilySearch: function(newVal, oldVal) {
      this.clearForm(false);
        let dataT = '([A-Z])+([0-9]).*'
        let matchesL = newVal.match(dataT);
if (matchesL!= null){
    this.form.familyId = matchesL[0]
} else{
    let regex = /\d+/g;
    let matches = newVal.match(regex);

    console.log(matchesL)
    this.form.familyId = parseInt(matches);
}

      this.form.family = newVal
      if (newVal) {
        axios.get(`/api/family/parents/${this.form.familyId}`)
          .then(res => {
            if (res.status === 200) {
              this.parents = res.data;
            }
          })
          .catch(error => console.log(error));
          return;
      }
      this.parents = {};
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/event/assistance.vue